import { ButtonBase, Typography } from '@mui/material';

import {
  CheckBoxCheckedIcon,
  CheckBoxUncheckedIcon,
  RadioBoxCheckedIcon,
  RadioBoxUncheckedIcon,
} from '@/icons';

export const Option = ({
  option,
  type,
  isSelected = false,
  onClick,
}: {
  option: string;
  type: 'radio' | 'checkbox';
  isSelected?: boolean;
  onClick: (option: string) => void;
}) => {
  return (
    <ButtonBase
      type="button"
      sx={[
        {
          cursor: 'pointer',
          userSelect: 'none',
          display: 'flex',
          justifyContent: 'flex-start',
          textAlign: 'left',
          width: '100%',
          alignItems: 'center',
          borderRadius: 2,
          bgcolor: 'surface.base',
          px: 2,
          py: 1.5,
          gap: 1,
          '&:hover': {
            opacity: 0.8,
          },
          '&:active': {
            bgcolor: 'secondary.light',
            color: 'secondary.main',
            opacity: 1,
          },
        },
        isSelected && {
          bgcolor: 'secondary.medium',
          color: 'secondary.main',
        },
      ]}
      onClick={() => onClick(option)}>
      {type === 'checkbox' ? (
        isSelected ? (
          <CheckBoxCheckedIcon />
        ) : (
          <CheckBoxUncheckedIcon />
        )
      ) : isSelected ? (
        <RadioBoxCheckedIcon />
      ) : (
        <RadioBoxUncheckedIcon />
      )}
      <Typography variant="body3SemiBold">{option}</Typography>
    </ButtonBase>
  );
};
